import { render, staticRenderFns } from "./IosUploadIcon.vue?vue&type=template&id=ec7efe2a&scoped=true&"
import script from "./IosUploadIcon.vue?vue&type=script&lang=js&"
export * from "./IosUploadIcon.vue?vue&type=script&lang=js&"
import style0 from "./IosUploadIcon.vue?vue&type=style&index=0&id=ec7efe2a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec7efe2a",
  null
  
)

export default component.exports